import { useMediaQuery } from '@mui/material';
import sizes from '../../styles/Sizes.module.scss';

export const useIsMobile = () => useMediaQuery(`(max-width: ${sizes.desktopMinWidth})`);
